import React from 'react';
import PageTransition from '../components/pageTransition';

const ErrorPage = () => {
  return ( 
    <PageTransition>
      <h1>Page Not Found</h1>
    </PageTransition>
  );
}

export default ErrorPage;